<script lang="ts">
import { defineComponent, onMounted, PropType } from 'vue'
import Sortable from 'sortablejs'

import ArtistListItem from './ArtistListItem.vue'

import { Artist, Store } from '../types'

export default defineComponent({
  name: 'ArtistList',
  components: {
    ArtistListItem,
  },
  props: {
    artists: {
      type: Array as PropType<Artist[]>,
    },
    timezone: {
      type: String,
      default: '',
    },
    emitter: {
      type: Object,
      required: true,
    },
    store: {
      type: Object as PropType<Store>,
      required: true,
    },
  },
  setup(props) {
    const selectArtist = (artistId: number): void => {
      props.emitter.emit('select-artist', artistId)
    }

    onMounted(() => {
      const el = document.getElementById('artists')

      if (el) {
        Sortable.create(el, {
          group: { name: 'timeslots', put: false, pull: true },
          sort: false,
          ghostClass: 'bg-gray-100',
          chosenClass: 'border-slipmat-600',
          onUpdate: function(evt) {
            console.log('Updated: ', evt)
          },
        })
      } else {
        console.log('FAIL: no HTML element for artists ')
      }
    })

    return {
      props,
      selectArtist,
    }
  },
})
</script>

<template>
  <ul class="space-y-2" id="artists" v-if="props.artists.length > 0">
    <li
      v-for="artist in props.artists"
      :key="artist.id"
      :id="'artist-' + artist.id"
      class="border-2 bg-white shadow overflow-hidden sm:rounded-md max-w-xs cursor-pointer"
      :class="{ 'border-slipmat-400': props.store.selectedArtistId === artist.id }"
      @click="selectArtist(artist.id)"
      :data-artist-id="artist.id"
    >
      <artist-list-item
        :artist="artist"
        :store="props.store"
        :emitter="props.emitter"
        :timezone="props.timezone"
      ></artist-list-item>
    </li>
  </ul>
  <div v-else class="text-gray-600">
    All artists booked.
  </div>
</template>
